import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { removeParam } from "../../Utils/UrlHelpers";
import actions from "../../Constants/actions";
import { TAB_NAME } from "../../Constants/evaluation";
export var initialState = {
  layouts: {},
  isError: {},
  isFetching: {},
  tabName: TAB_NAME.INITIAL,
  registrationResponse: null,
  isExist: false
};
export var urls = {
  getLayout: function getLayout(layoutSource) {
    return "/api/cxe/".concat(layoutSource, "/layouts");
  },
  getLayoutViaBFF: function getLayoutViaBFF(layoutSource) {
    return "/api/consumer-bff/layouts/".concat(layoutSource);
  }
};
var changeStatus = function changeStatus(state, type, status, key) {
  return _defineProperty({}, key, Object.assign({}, state[key], _defineProperty({}, type, status)));
};
var changeIsFetchingStatus = function changeIsFetchingStatus(state, type, status) {
  return changeStatus(state, type, status, 'isFetching');
};
var changeIsErrorStatus = function changeIsErrorStatus(state, type, status) {
  return changeStatus(state, type, status, 'isError');
};
var getNewLayouts = function getNewLayouts(state, action, updatedUrl) {
  if (!action.data) {
    return state.layouts;
  }
  var newLayout = _defineProperty({}, updatedUrl, action.data);
  return Object.assign({}, state.layouts, newLayout);
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var updatedUrl = removeParam('userVisit', action.url);
  switch (action.type) {
    case 'REQUEST_CXE_LAYOUT':
      return Object.assign(Object.assign(Object.assign({}, state), changeIsFetchingStatus(state, updatedUrl, true)), changeIsErrorStatus(state, updatedUrl, false));
    case 'RECEIVE_CXE_LAYOUT':
      return Object.assign(Object.assign(Object.assign(Object.assign({}, state), {
        layouts: getNewLayouts(state, action, updatedUrl)
      }), changeIsFetchingStatus(state, updatedUrl, false)), changeIsErrorStatus(state, updatedUrl, false));
    case 'ERROR_CXE_LAYOUT':
      return Object.assign(Object.assign(Object.assign({}, state), changeIsFetchingStatus(state, updatedUrl, false)), changeIsErrorStatus(state, updatedUrl, true));
    case actions.SET_CURRENT_TAB:
      return Object.assign(Object.assign({}, state), {
        tabName: action.data
      });
    case actions.SET_VALUATION_REGISTRATION_RESPONSE:
      return Object.assign(Object.assign({}, state), {
        registrationResponse: action.data
      });
    case actions.SET_LAYOUT_EXIST:
      return Object.assign(Object.assign({}, state), {
        isExist: action.data
      });
    default:
      return state;
  }
});